module.exports = __webpack_public_path__ + "img/shared-mailbox.9facfdf9.png";